export const formatINR = (n) =>
  n == null ? "—" : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export function priceInfo(service) {
  if (!service || service.custom_quote || service.price_inr == null) {
    return { custom: true, main: "Custom quote", prefix: "Scoped to your brief", unit: "" };
  }
  return { custom: false, main: formatINR(service.price_inr), prefix: "Starting at", unit: service.price_unit || "" };
}

export function gstTag(pricing, price) {
  if (!pricing || price == null || pricing.gst_mode === "hidden") return null;
  if (pricing.gst_mode === "inclusive") return { short: "incl. GST", total: null };
  const r = Number(pricing.gst_rate || 0);
  return { short: `+ ${r}% GST`, total: `${formatINR(price + Math.round((price * r) / 100))} incl. GST` };
}

export function gstLine(pricing) {
  if (!pricing || pricing.gst_mode === "hidden") return "";
  return pricing.gst_note || (pricing.gst_mode === "inclusive" ? "Prices include GST." : `Prices exclude GST (${pricing.gst_rate}%).`);
}

export const GST_LABEL = { exclusive: "GST extra", inclusive: "GST included", not_applicable: "GST not applicable" };

export function safeHref(h) {
  if (!h) return "/";
  const s = String(h).trim();
  return s.startsWith("/") || s.startsWith("https://") || s.startsWith("http://") || s.startsWith("mailto:") || s.startsWith("#") ? s : "/";
}

export const isExternal = (h) => /^(https?:|mailto:)/.test(h || "");

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export function embedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return { type: "iframe", src: `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0` };
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return { type: "iframe", src: `https://player.vimeo.com/video/${vm[1]}` };
  const gd = url.match(/drive\.google\.com\/file\/d\/([\w-]+)/);
  if (gd) return { type: "iframe", src: `https://drive.google.com/file/d/${gd[1]}/preview` };
  if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) return { type: "video", src: url };
  return { type: "link", src: url };
}

export const toLines = (arr) => (arr || []).join("\n");
export const fromLines = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean);

export const PORTFOLIO_CATEGORIES = ["Talking Head", "Podcast Clips", "Fashion & Editorial", "Brand & Promotional Videos", "Founder Content", "Motion Graphics"];
